export enum NewsPerView {
  Small = 3,
  Large = 4,
}
